import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import Logo from '../../assets/Logo.png';

type GlassNavProps = {
  className?: string;
};

export function GlassNav({ className }: GlassNavProps) {
  return (
    <header
      className={cn(
        'glass sticky top-0 z-40 px-4 py-4 sm:px-6 sm:py-5',
        className,
      )}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 sm:gap-4">
        <Link to="/" className="flex items-center gap-2">
          <img src={Logo} alt="Mopion Inc." className="h-48 w-auto sm:h-56 md:h-64 lg:h-72 xl:h-80" />
        </Link>
        <nav className="flex items-center gap-2 text-sm sm:gap-4">
          <Link
            to="/about"
            className="hidden rounded-md px-3 py-2 font-medium text-primary transition-colors hover:bg-surface-container sm:px-4 md:inline-block"
          >
            About
          </Link>
          <Link
            to="/contact"
            className="hidden rounded-md px-3 py-2 font-medium text-primary transition-colors hover:bg-surface-container sm:px-4 md:inline-block"
          >
            Contact
          </Link>
          <Link
            to="/login"
            className="rounded-md px-3 py-2 font-semibold text-primary transition-colors hover:bg-surface-container sm:px-4"
          >
            <span className="hidden sm:inline">Sign in</span>
            <span className="sm:hidden">Login</span>
          </Link>
          <Link
            to="/register"
            className="rounded-md bg-secondary px-3 py-2 font-semibold text-white transition-opacity hover:opacity-90 sm:px-4"
          >
            <span className="hidden sm:inline">Create account</span>
            <span className="sm:hidden">Sign up</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}
